import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { TBootsColor } from "../../../Interfaces/Utils/Style/StyleInterfaces";
import IconOrSpinner from "../../Utils/IconOrSpinner";

export interface IFormSubmitButtonProps
    extends React.DetailedHTMLProps<
        React.ButtonHTMLAttributes<HTMLButtonElement>,
        HTMLButtonElement
    > {
    icon: IconProp;
    iconSize?: SizeProp;
    noDiv?: boolean;

    outline?: boolean;
    color: TBootsColor;

    wrapperClassName?: string;
    clearClasses?: boolean;

    loading?: boolean;
    loadingSize?: "lg" | "sm" | "xl";
}

export function FormSubmitButton(props: IFormSubmitButtonProps) {
    const {
        icon,
        noDiv,
        iconSize,
        outline,
        color,
        wrapperClassName,
        loading,
        loadingSize,
        clearClasses,
        ...buttonProps
    } = props;

    const buttonClasses = !clearClasses
        ? `d-flex g-2 align-items-center justify-content-center ${
              buttonProps.className ?? ""
          }`
        : buttonProps.className ?? "";

    const buttonElement = (
        <button
            {...buttonProps}
            type="submit"
            disabled={buttonProps.disabled ?? loading}
            className={`btn btn-${
                outline ? "outline-" : ""
            }${color} ${buttonClasses}`}
        >
            <IconOrSpinner
                icon={icon}
                size={iconSize}
                loading={loading ?? false}
                loadingSize={loadingSize}
            />
            {buttonProps.children}
        </button>
    );

    return (
        <>
            {!noDiv ? (
                <div className={wrapperClassName ?? "col-12"}>
                    {buttonElement}
                </div>
            ) : (
                buttonElement
            )}
        </>
    );
}
